import { render, staticRenderFns } from "./qiuzhi.vue?vue&type=template&id=5d178812&scoped=true&"
import script from "./qiuzhi.vue?vue&type=script&lang=js&"
export * from "./qiuzhi.vue?vue&type=script&lang=js&"
import style0 from "./qiuzhi.vue?vue&type=style&index=0&id=5d178812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d178812",
  null
  
)

export default component.exports